module.exports = __webpack_public_path__ + "static/img/27.d418b8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/image/27.jpg
// module id = Zzmh
// module chunks = 0